(function () {
  function queryShadowRoots(root, selector) {
    const results = [];
    results.push(...root.querySelectorAll(selector));
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) {
        results.push(...queryShadowRoots(el.shadowRoot, selector));
      }
    });
    return results;
  }

  function applyStyles() {
    document.querySelectorAll('.shopify-app-block').forEach((block) => {
      queryShadowRoots(block, '#form-container-ref section[data-sizing="form-wrapper"]').forEach((section) => {
        section.style.setProperty('margin', '0', 'important');
        section.style.setProperty('max-width', 'none', 'important');
      });

      queryShadowRoots(block, '#form-container-ref section > h2').forEach((h2) => {
        h2.style.setProperty('font-family', 'var(--heading-font-family)', 'important');
        h2.style.setProperty('font-size', '14px', 'important');
        h2.style.setProperty('font-weight', '200', 'important');
        h2.style.setProperty('text-transform', 'uppercase', 'important');
        h2.style.setProperty('margin-bottom', '1rem', 'important');
      });

      queryShadowRoots(block, '#form-container-ref section > div').forEach((p) => {
        p.style.setProperty('font-family', 'var(--heading-font-family)', 'important');
        p.style.setProperty('font-size', '1.25rem', 'important');
        p.style.setProperty('font-weight', '300', 'important');
        p.style.setProperty('line-height', '33px', 'important');
      });

      queryShadowRoots(block, '#form-container-ref section:has(> h2)').forEach((section) => {
        section.style.setProperty('margin-top', '0', 'important');
      });

      queryShadowRoots(block, '#form-container-ref form').forEach((form) => {
        form.style.setProperty('gap', '4px', 'important');
      });

      queryShadowRoots(block, '#form-container-ref input').forEach((input) => {
        input.style.setProperty('border-radius', '0', 'important');
      });

      queryShadowRoots(block, '#form-container-ref button').forEach((button) => {
        button.style.setProperty('margin-top', '4px', 'important');
        button.style.setProperty('border-radius', '0', 'important');
        button.style.setProperty('font-family', 'var(--heading-font-family)', 'important');
        button.style.setProperty('font-size', '12px', 'important');
        button.style.setProperty('font-weight', '500', 'important');
        button.style.setProperty('line-height', '128%', 'important');
      });

      queryShadowRoots(block, '#form-container-ref div > div > p').forEach((p) => {
        p.style.setProperty('padding-top', '8px', 'important');
        p.style.setProperty('font-family', 'var(--heading-font-family)', 'important');
        p.style.setProperty('font-size', '12px', 'important');
        p.style.setProperty('font-weight', '200', 'important');
        p.style.setProperty('line-height', '18px', 'important');
      });
    });
  }

  const observer = new MutationObserver(applyStyles);
  observer.observe(document.body, { childList: true, subtree: true });
})();
